import React, { useRef } from 'react';
import { makeStyles } from '@fluentui/react-components';
import CustomerHoverCard from './CustomerHoverCard';
import { useHoverCard } from '../hooks/useHoverCard';

interface CustomerNameWithHoverCardProps {
  customerId: string;
  customerName: string;
  customerEmail: string;
  customerType?: string;
  securityDeposit?: string;
  bookings?: number;
  revenue?: number;
  customerSince?: string;
}

const useStyles = makeStyles({
  customerName: {
    color: '#0078d4',
    textDecoration: 'none',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'block',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

const CustomerNameWithHoverCard: React.FC<CustomerNameWithHoverCardProps> = ({
  customerId,
  customerName,
  customerEmail,
  customerType,
  securityDeposit,
  bookings,
  revenue,
  customerSince,
}) => {
  const styles = useStyles();
  const nameRef = useRef<HTMLSpanElement>(null);

  const hoverCard = useHoverCard({
    showDelay: 150,
    hideDelay: 150,
    onOpen: () => {
      // Add a style to the row to disable hover background
      const row = nameRef.current?.closest('tr');
      if (row) {
        (row as HTMLElement).style.setProperty('background-color', 'transparent', 'important');
      }
    },
    onClose: () => {
      // Remove the background color override from the row
      const row = nameRef.current?.closest('tr');
      if (row) {
        (row as HTMLElement).style.removeProperty('background-color');
      }
    },
  });

  return (
    <>
      <span
        ref={nameRef}
        className={styles.customerName}
        onMouseEnter={hoverCard.onTriggerMouseEnter}
        onMouseLeave={hoverCard.onTriggerMouseLeave}
      >
        {customerName}
      </span>
      <CustomerHoverCard
        customerId={customerId}
        customerName={customerName}
        customerEmail={customerEmail}
        customerType={customerType}
        securityDeposit={securityDeposit}
        bookings={bookings}
        revenue={revenue}
        customerSince={customerSince}
        anchorRef={nameRef}
        isVisible={hoverCard.isVisible}
        onClose={hoverCard.close}
        onMouseEnter={hoverCard.onCardMouseEnter}
        onMouseLeave={hoverCard.onCardMouseLeave}
      />
    </>
  );
};

export default CustomerNameWithHoverCard;
